import { render, staticRenderFns } from "./ViewWebhook.vue?vue&type=template&id=3d273a60&"
import script from "./ViewWebhook.vue?vue&type=script&lang=ts&"
export * from "./ViewWebhook.vue?vue&type=script&lang=ts&"
import style0 from "./ViewWebhook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports